import React, { useEffect, useState } from 'react';

import { Box, IconButton, Tooltip, useTheme } from '@mui/material';

import { IconWrapper } from 'components/Icon';

import { useToggleSupplierStar } from '../api/toggleSupplierStar';

export const SupplierStarButton = ({
  companyID,
  isStarred = false,
  onChange,
  size = 20,
  sx = {},
}) => {
  const theme = useTheme();
  const [starred, setStarred] = useState(isStarred);

  useEffect(() => {
    setStarred(isStarred);
  }, [isStarred]);

  const { mutate, isPending } = useToggleSupplierStar({
    onSuccess: ({ starred }) => {
      if (onChange) onChange(starred);
    },
    onError: ({ starred }) => setStarred(!starred),
  });

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const next = !starred;
    setStarred(next);
    mutate({ companyID, starred: next });
  };

  const color = starred ? theme.palette.warning.main : theme.palette.grey[500];
  const label = starred ? 'Remove from starred suppliers' : 'Star this supplier';

  return (
    <Tooltip title={label}>
      <Box component="span" sx={{ display: 'inline-flex', ...sx }}>
        <IconButton
          onClick={handleClick}
          disabled={isPending}
          aria-label={label}
          aria-pressed={starred}
          size="small"
        >
          <IconWrapper
            icon={starred ? 'star' : 'starOutline'}
            height={size}
            sx={{
              display: 'flex',
              svg: {
                height: size,
                width: size,
                color,
                stroke: color,
                strokeWidth: starred ? 0 : 1.5,
              },
            }}
          />
        </IconButton>
      </Box>
    </Tooltip>
  );
};
